<div class="d-flex justify-content-center p-4">
  <span>Your focused entity is being changed.</span>
</div>
